<template>
  <div id="loadingScreen" style="visibility:hidden; opacity:1;">
    <div class="pageLoadingIcon"></div>
  </div>
</template>
<script>
  // import { mapState, mapActions, mapMutations } from 'vuex';
  export default {
    name: 'app-page-loading-icon',
  };
</script>

<style>
  #loadingScreen {
    width: 100%;
    height: 100%;
    background-color: #000000;
    background-color: rgba(0, 0, 0, 0.75);
    background-color: transparent \9;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#BF000000, endColorstr=#BF000000);
    zoom: 1;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1000;
    text-align: center;
    opacity: 1;
    filter: alpha(opacity=100);
    zoom: 1;
  }

  #loadingScreen .pageLoadingIcon {
    background-image: url("../assets/images/preloader-anim.gif");
    width: 50px;
    height: 50px;
    position: relative;
    top: 45%;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// ThePageLoadingIcon.vue?5d183adb